module.exports = __webpack_public_path__ + "img/whatsapp.d9c6eb09.png";